import { Navigate, Route, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import ServicePageEditor from './ServicePageEditor';
import AboutPageEditor from './AboutPageEditor';
import HomePageEditor from './HomePageEditor';
import ServicesPageEditor from './ServicesPageEditor';
import CaseStudiesPageEditor from './CaseStudiesPageEditor';
import ContactPageEditor from './ContactPageEditor';
import './Admin.css';

export default function AdminApp() {
  return (
    <>
      <Helmet>
        <title>Admin | Databiqs</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route path="service-pages/:slug/edit" element={<ServicePageEditor />} />
        <Route path="about-page/edit" element={<AboutPageEditor />} />
        <Route path="home-page/edit" element={<HomePageEditor />} />
        <Route path="services-page/edit" element={<ServicesPageEditor />} />
        <Route path="case-studies-page/edit" element={<CaseStudiesPageEditor />} />
        <Route path="contact-page/edit" element={<ContactPageEditor />} />
        <Route path="/" element={<AdminDashboard />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </>
  );
}
